import { render, staticRenderFns } from "./LogOut.vue?vue&type=template&id=059a6411&lang=pug"
import script from "./LogOut.vue?vue&type=script&lang=js"
export * from "./LogOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports